var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.269,
    height: 56.405,
    viewBox: "0 0 48.269 56.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exc-deal",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101397",
    "data-name": "Path 101397",
    d: "M-8221.436-3117.3s-8.958-4.061-3-16.071c.05,0,7.137-13.142,18.605-6.152a15.5,15.5,0,0,1,4.923,19.664c.066-.094-2.215,6.3-19.887,2.859C-8220.9-3116.929-8221.436-3117.3-8221.436-3117.3Z",
    transform: "translate(8247.499 3141.575)",
    fill: "#e7f4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(0 3.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_02-Heart_copy_5",
    "data-name": "02-Heart copy 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122890",
    "data-name": "Path 122890",
    d: "M21.259,19.441s4.378-4.569,4.378-10.051a13.017,13.017,0,0,0-1.752-6.4,11.476,11.476,0,0,1,9.633,3.655c3.5,3.655,6.129,12.792,6.129,12.792A7.124,7.124,0,0,0,41.4,14.872a11.506,11.506,0,0,0-.876-4.569s5.671,2.915,8.756,10.964c1.751,4.569,1.751,9.137,1.751,13.706A20.7,20.7,0,0,1,30.015,55.989,20.7,20.7,0,0,1,9,34.974c0-9.137,4.378-13.7,5.254-16.447a25.077,25.077,0,0,0,.875-6.4,15.14,15.14,0,0,1,3.5,2.741,13.526,13.526,0,0,1,2.627,4.569Z",
    transform: "translate(-8.997 -2.933)",
    fill: "#ffb369"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41252",
    "data-name": "Group 41252",
    transform: "translate(0.001 0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122891",
    "data-name": "Path 122891",
    d: "M43.787,18.291c.99,2.542,1.579,4.587,1.579,4.587a7.124,7.124,0,0,0,1.751-4.569,11.506,11.506,0,0,0-.876-4.569,13.448,13.448,0,0,1,2.075,1.447A17.694,17.694,0,0,0,43.5,11a11.506,11.506,0,0,1,.876,4.569A6.739,6.739,0,0,1,43.787,18.291Z",
    transform: "translate(-11.975 -3.642)",
    fill: "#eb7f58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122892",
    "data-name": "Path 122892",
    d: "M23.318,18.463a14.535,14.535,0,0,1,1.918,3.72s4.378-4.569,4.378-10.051a13.016,13.016,0,0,0-1.752-6.4,11.281,11.281,0,0,1,7.9,2.147A11.765,11.765,0,0,0,25.12,3a13.016,13.016,0,0,1,1.752,6.4c0,3.968-2.288,7.447-3.555,9.072Z",
    transform: "translate(-10.234 -2.947)",
    fill: "#eb7f58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122893",
    "data-name": "Path 122893",
    d: "M11.741,38.584c0-9.137,4.378-13.7,5.254-16.447a25.072,25.072,0,0,0,.875-6.4,12.917,12.917,0,0,1,1.645,1.086,9.143,9.143,0,0,0-.882-1.086A15.14,15.14,0,0,0,15.128,13a25.072,25.072,0,0,1-.875,6.4C13.378,22.138,9,26.706,9,35.843a20.756,20.756,0,0,0,7.467,16.226,20.985,20.985,0,0,1-4.726-13.485Z",
    transform: "translate(-8.998 -3.815)",
    fill: "#eb7f58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41253",
    "data-name": "Group 41253",
    transform: "translate(13.708 23.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122894",
    "data-name": "Path 122894",
    d: "M27.655,36.31a3.655,3.655,0,1,1,3.655-3.655,3.655,3.655,0,0,1-3.655,3.655Zm0-5.482a1.827,1.827,0,1,0,1.827,1.827A1.827,1.827,0,0,0,27.655,30.827Z",
    transform: "translate(-24 -29)",
    fill: "#fafbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122895",
    "data-name": "Path 122895",
    d: "M35.655,48.31a3.655,3.655,0,1,1,3.655-3.655,3.655,3.655,0,0,1-3.655,3.655Zm0-5.482a1.827,1.827,0,1,0,1.827,1.827,1.827,1.827,0,0,0-1.827-1.827Z",
    transform: "translate(-24.69 -30.036)",
    fill: "#fafbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122896",
    "data-name": "Path 122896",
    d: "M25.914,45.619a.914.914,0,0,1-.693-1.508L36.185,31.319a.914.914,0,1,1,1.388,1.189L26.608,45.3a.913.913,0,0,1-.694.319Z",
    transform: "translate(-24.086 -29.173)",
    fill: "#fafbfb"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg3.530831ff05d9ef238282dd4b5469bd38.svg";
export { ForwardRef as ReactComponent };